import React from 'react';

/**
 * Default personnel marker panel shown from map markers.
 * Can be replaced per-map by passing `panelComponent` into `PersonellLayer`.
 */
const PersonnelMarkerPanel = ({
  displayName,
  timestampLabel,
  isClockedIn,
  isCurrentUser = false,
  messagePending = false,
  showMessageAction = true,
  onMessage,
  messageLabel = 'Message',
  pendingMessageLabel = 'Opening chat...',
  selfMessageLabel = 'This is you',
}) => {
  return (
    <div className="responder-personnel-panel">
      <div className="responder-personnel-panel__title">{displayName}</div>
      <div className="responder-personnel-panel__meta">
        {isClockedIn ? 'Clocked In' : 'Offline'} - Last Update: {timestampLabel}
      </div>
      {showMessageAction && (
        <button
          type="button"
          className="responder-personnel-panel__action responder-interactive-action"
          disabled={isCurrentUser || messagePending}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (isCurrentUser) return;
            onMessage?.();
          }}
        >
          {messagePending ? pendingMessageLabel : isCurrentUser ? selfMessageLabel : messageLabel}
        </button>
      )}
    </div>
  );
};

export default PersonnelMarkerPanel;
